import { get, post, put, deleted } from '..';
import routes from './routes';

const DeliveryManagementServices = {
  getDeliveries: async (params) => {
    const data = await get(routes.getDeliveries, params);
    return data;
  },
  getDeliveryReceipts: async (obj) => {
    const data = await post(routes.getDeliveryReceipts, obj);
    return data;
  },
}

export default DeliveryManagementServices